import React, { useState, useEffect, act } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NavTabs = (props) => {
  const location = useLocation();
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();

  function handleChange(e, value) {
    setTab(value);
    switch (value) {
      case 0:
        navigate("/");
        break;
      case 1:
        navigate("/modules");
        break;
      case 2:
        navigate("/voorwaardengids");
        break;
      case 3:
        navigate("/customer-service");
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (
      location.pathname === "" ||
      location.pathname === "/"
    ) {
      setTab(0);
    } else if (
      location.pathname === "/modules" ||
      location.pathname === "/modules/" ||
      location.pathname === "/new-check" ||
      location.pathname === "/new-check/"
    ) {
      setTab(1);
    } else if (
      location.pathname === "/voorwaardengids" ||
      location.pathname === "/voorwaardengids/"
    ) {
      setTab(2);
    } else if (
      location.pathname === "/customer-service" ||
      location.pathname === "/customer-service/"
    ) {
      setTab(3);
    }
  }, [location]);

  return (
    <Tabs
      value={tab}
      onChange={handleChange}
      TabIndicatorProps={{
        style: { display: "none" }, // Hides the underline
      }}
    >
      <Tab
        label={t("myChecks")}
        id={"myChecks"}
        sx={{
          fontWeight: tab === 0 ? 600 : 400,
          textTransform: "none",
          fontSize: "16px",
          border: "none",
        }}
        onClick={() => {
          if (location.pathname === "/new-check") {
            navigate("/");
          }
        }}
      />
      <Tab
        label={t("Categories")}
        id={"newCheck"}
        sx={{
          fontWeight: tab === 1 ? 600 : 400,
          textTransform: "none",
          fontSize: "16px",
          border: "none",
        }}
        onClick={() => {
          if (location.pathname !== "/modules") {
            navigate("/new-check");
          }
        }}
      />
      <Tab
        label={t("voorwaardengids")}
        id={"voorwaardengids"}
        sx={{
          fontWeight: tab === 2 ? 600 : 400,
          textTransform: "none",
          fontSize: "16px",
          border: "none",
        }}
        onClick={() => {
          navigate("/voorwaardengids");
        }}
      />

    </Tabs>
  );
};

export default NavTabs;
